import {addHours, parseISO} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {Nullish, parseDate} from 'shared/web';

/**
 * The backend keeps the offer validity as a calendar date (midnight UTC of that date, or the time
 * the default validity was computed) and accepts the offer through the end of that UTC day. The
 * countdown therefore ends at the start of the next UTC day, not at the stored instant. A date-only
 * value is already that calendar date; parsing it would give local midnight and shift the date.
 */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export const getOfferValidityDeadline = (offerValidTo: string | Nullish) => {
  if (isNil(offerValidTo) || isEmpty(offerValidTo)) {
    return null;
  }
  const validDate = DATE_ONLY.test(offerValidTo)
    ? offerValidTo
    : parseDate(offerValidTo).toISOString().slice(0, 10);
  return addHours(parseISO(`${validDate}T00:00:00Z`), 24);
};
